import { Controller } from '@hotwired/stimulus'
import { Tooltip } from 'bootstrap'

export default class extends Controller {
  connect() {
    var tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    )
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new Tooltip(tooltipTriggerEl)
    })
  }

  disconnect() {
    // Optional: Tooltips aufräumen wenn Controller disconnected wird
    var tooltips = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    tooltips.forEach(element => {
      const tooltip = Tooltip.getInstance(element)
      if (tooltip) {
        tooltip.dispose()
      }
    })
  }
}
